import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconNowAvailable } from '@redteclab/icons'

export const OrderSubOrderNowIndicator: FC = () => {
  return (
    <span className="flex items-center gap-1 italic text-dark-brand">
      <IconNowAvailable className="rounded-full" />
      <FormattedMessage id="accountOveriew.lastOrder.nowLabel" />
    </span>
  )
}
